import { createSlice } from "@reduxjs/toolkit";

const cartSlice=createSlice({
    name : 'cart',
    initialState : {
        items :[]
    },
    reducers :{
        addItem : (state , action)=>{
            console.log('action in add item',action);
            state.items.push(action.payload)
        },
        removeItem : (state , action)=>{
            state.items.pop();
        },
        clearCart : (state , action)=>{
            state.items.length=0;
        }
    }
})


console.log('cartslice.reducer',cartSlice.reducer);
export default cartSlice.reducer;
export const {addItem,removeItem,clearCart}=cartSlice.actions;